import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import LoadingLayout from 'layout/MainLayout/LoadingLayout';
import useAuth from 'hooks/useAuth';
import useConfig from 'hooks/useConfig';
import SectionGuard from 'utils/route-guard/SectionGuard';

const MainLayout = Loadable(lazy(() => import('layout/MainLayout')));

// maintenance routing
const MaintenanceError = Loadable(lazy(() => import('views/pages/maintenance/Error')));
const MaintenanceComingSoon1 = Loadable(lazy(() => import('views/pages/maintenance/ComingSoon/ComingSoon1')));
const MaintenanceComingSoon2 = Loadable(lazy(() => import('views/pages/maintenance/ComingSoon/ComingSoon2')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('views/pages/maintenance/UnderConstruction')));

const MaintenanceWrapper = ({ Component, ...props }: { Component: React.ComponentType<any>; [key: string]: any }) => {
    const { user, isReady } = useAuth();
    const { ready } = useConfig();
    const content = <Component {...props} />;

    if (!(isReady && ready)) {
        return <LoadingLayout />;
    }
    if (user) {
        return (
            <SectionGuard>
                <MainLayout>{content}</MainLayout>
            </SectionGuard>
        );
    }
    return <div>{content}</div>;
};

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/pages/error',
            element: <MaintenanceWrapper Component={MaintenanceError} />
        },
        {
            path: '/pages/coming-soon1',
            element: <MaintenanceWrapper Component={MaintenanceComingSoon1} />
        },
        {
            path: '/pages/coming-soon2',
            element: <MaintenanceWrapper Component={MaintenanceComingSoon2} />
        },
        {
            path: '/pages/under-construction',
            element: <MaintenanceWrapper Component={MaintenanceUnderConstruction} />
        }
    ]
};

export default AuthenticationRoutes;
